import Dictionary from "./components/Dictionary";

function App() {
  return <Dictionary />;
}

export default App;
